export default {"src":"/_next/static/media/lockInRate.da54661c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};